import React from 'react';

function NotServiceableScreen({ selectedAddress, onChangeLocation, onNotifyMe }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      height: '100vh',
      padding: '20px',
      paddingTop: '40px',
      background: 'linear-gradient(135deg, #fef3f0 0%, #fff5f5 50%, #fef3f0 100%)',
      textAlign: 'center',
      animation: 'fadeIn 0.5s ease-out',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
    }}>
      {/* Crying Emoji with Animation */}
      <div style={{
        fontSize: '80px',
        marginBottom: '16px',
        animation: 'cry 2s ease-in-out infinite',
        filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.1))',
      }}>
        😢
      </div>

      {/* Title */}
      <h1 style={{
        margin: '0 0 12px 0',
        fontSize: '24px',
        fontWeight: '800',
        color: '#991b1b',
        letterSpacing: '-0.5px',
        animation: 'slideUp 0.6s ease-out 0.2s backwards',
      }}>
        We're Not Here Yet
      </h1>

      {/* Message */}
      <p style={{
        margin: '0 0 24px 0',
        fontSize: '15px',
        lineHeight: '1.5',
        color: '#7f1d1d',
        maxWidth: '90%',
        fontWeight: '500',
        animation: 'slideUp 0.6s ease-out 0.3s backwards',
      }}>
        We're working hard to bring Flash delivery to your location soon!
      </p>

      {/* Selected Address Card */}
      {selectedAddress && (
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '16px',
          marginBottom: '20px',
          border: '2px solid #fecaca',
          maxWidth: '90%',
          width: '100%',
          animation: 'slideUp 0.6s ease-out 0.4s backwards',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            textAlign: 'left',
          }}>
            <span style={{ fontSize: '24px', flexShrink: 0 }}>📍</span>
            <div style={{ flex: 1 }}>
              <div style={{
                fontSize: '13px',
                color: 'var(--text-muted)',
                marginBottom: '4px',
                fontWeight: '600',
              }}>
                Selected Location
              </div>
              <div style={{
                fontSize: '15px',
                fontWeight: '700',
                color: 'var(--text-primary)',
                marginBottom: '4px',
              }}>
                {selectedAddress.label || selectedAddress.type || 'Your Address'}
              </div>
              <div style={{
                fontSize: '13px',
                color: 'var(--text-secondary)',
                lineHeight: '1.4',
              }}>
                {selectedAddress.area}, {selectedAddress.city}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '100%',
        maxWidth: '90%',
        animation: 'slideUp 0.6s ease-out 0.5s backwards',
      }}>
        <button
          onClick={onChangeLocation}
          style={{
            width: '100%',
            background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            padding: '14px',
            fontSize: '15px',
            fontWeight: '700',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(255,107,53,0.3)',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(255,107,53,0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255,107,53,0.3)';
          }}
        >
          <span style={{ fontSize: '18px' }}>📍</span>
          Change Location
        </button>

        <button
          onClick={onNotifyMe}
          style={{
            width: '100%',
            background: 'white',
            color: 'var(--primary)',
            border: '2px solid var(--primary)',
            borderRadius: '12px',
            padding: '14px',
            fontSize: '15px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'var(--primary-bg)';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          <span style={{ fontSize: '18px' }}>🔔</span>
          Notify Me When Available
        </button>
      </div>

      {/* Info Cards */}
      <div style={{
        marginTop: '32px',
        marginBottom: '20px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
        gap: '12px',
        width: '100%',
        maxWidth: '90%',
        animation: 'slideUp 0.6s ease-out 0.6s backwards',
      }}>
        {[
          { icon: '🚀', title: 'Expanding Fast', desc: 'New areas weekly' },
          { icon: '⚡', title: 'Quick Delivery', desc: '15-45 minutes' },
          { icon: '💯', title: 'Quality Products', desc: 'Fresh & verified' },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '12px',
              border: '1px solid var(--border-light)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            }}
          >
            <div style={{ fontSize: '28px', marginBottom: '6px' }}>{item.icon}</div>
            <div style={{
              fontSize: '12px',
              fontWeight: '700',
              color: 'var(--text-primary)',
              marginBottom: '3px',
            }}>
              {item.title}
            </div>
            <div style={{
              fontSize: '11px',
              color: 'var(--text-muted)',
            }}>
              {item.desc}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes cry {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          25% {
            transform: translateY(-10px) rotate(-5deg);
          }
          50% {
            transform: translateY(0) rotate(0deg);
          }
          75% {
            transform: translateY(-10px) rotate(5deg);
          }
        }
      `}</style>
    </div>
  );
}

export default NotServiceableScreen;

// Made with Bob
